import { createSlice } from "@reduxjs/toolkit";

const manageMetalsSlice = createSlice({
  name: "metals",
  initialState: {
    message: null,
    error: null,
    karatList: [],
    metals: [],
    purityList: [],
    enabledMetal: [],
    metalHistory: [],
    metalHistoryTotal: 0, 
  },
  reducers: {
    addBullion: () => {},
    fetchKaratRequest: () => {}, // ✅ <- ADD THIS

    addMetal: () => {},
    addKarat: () => {},
    addQuantity: () => {},
    updateBuySellRate: () => {},
    addKaratPurity: () => {},
    enableDisableMetals: () => {},
    addPurity: () => {},
    fetchKarat: () => {},
    changeStatus: () => {},
    updateSellOutTime: () => {},
    updateRedeemTimeOut: () => {},
    removeQuantity: () => {},
    downloadMetalReport: () => {},
    getPuritiesByKaratId: () => {},
    getMetalHistory: () => {},
    setBullions: (state, action) => {
      state.metals = action.payload;
    },
    getMetals: (state, action) => {
      state.metals = action.payload;
    },
    setMetals: (state, action) => {
      state.metals = action.payload;
    },
    setKaratList: (state, action) => {
      state.karatList = action.payload;
    },
    setPurityList: (state, action) => {
      state.purityList = action.payload;
    },
    setEnabledMetal: (state, action) => {
      state.enabledMetal = action.payload;
    },
    setMetalHisory: (state, action) => {
      state.metalHistory = action.payload.data;
      state.metalHistoryTotal = action.payload.total;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearMessage: (state) => {
      state.error = null;
      state.message = null;
    },
  },
});

export const {
  addKarat,
  fetchKaratRequest,
  fetchKarat,
  getMetals,
  addMetal,
  setMetals,
  addPurity,
  changeStatus,
  updateSellOutTime,
  addQuantity,
  addBullion,
  removeQuantity,
  downloadMetalReport,
  updateBuySellRate,
  addKaratPurity,
  enableDisableMetals,
  setMessage,
  setKaratList,
  setError,
  clearMessage,
  setPurityList,
  getPuritiesByKaratId,
  setEnabledMetal,
  getMetalHistory,
  setMetalHisory,
  updateRedeemTimeOut,
} = manageMetalsSlice.actions;

export default manageMetalsSlice.reducer;
